import styles from "../styles/profile.module.scss";
import Button from "../../../components/shared/Button/Button";
import { useDispatch } from "react-redux";
import { setOpenModal } from "../../../store/slices/modals.slice";
import { useTranslation } from "react-i18next";
import useSubscriptions from "../../../hooks/useSubscriptions";
import { useAppSelector } from "../../../store/store";

const RemoveSubscriptionModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const userData = useAppSelector((state: any) => state.auth.userData);

  const { cancelSubscribe } = useSubscriptions();

  const removeHandler = async (data: any) => {
    await cancelSubscribe(data);
    dispatch(setOpenModal("removeSubscriptionSuccess"));
  };

  return (
    <div className={styles.subscriptionModalWrapper}>
      <div className={styles.removeSubModalTextContent}>
        <div className={styles.removeSubModalTitle}>{t("removeSubModalTitle")}</div>
        <div className={styles.removeSubModalDescr}>
          {t("removeSubModalDesc1")}
          {userData.product_id === 1 ? `"${t("oneMonth")}" ` : ""}
          {userData.product_id === 2 ? `"${t("oneYear")}" ` : ""}
          {t("removeSubModalDesc2")}
        </div>
      </div>
      <div className={styles.subscriptionModalButtonWrapper}>
        <Button title={t("saveSub")} submit={() => dispatch(setOpenModal(""))} className={styles.confirm} />

        <Button title={t("removeSub")} submit={() => removeHandler(userData)} className={styles.cancel} />
      </div>
    </div>
  );
};

export default RemoveSubscriptionModal;
